import { Badge } from "@mui/material";
import { CartProduct } from "@/interfaces";
import { colors } from "@/theme";
import * as S from "./styles";

export type CartProductItemProps = {
  item?: CartProduct;
  badge?: boolean;
  defaultProductImageUrl?: string;
};

const CartProductItem: React.FC<CartProductItemProps> = ({
  item = undefined,
  badge = true,
  defaultProductImageUrl = undefined,
}) => {
  return item ? (
    <S.CartProductItemContainer>
      {badge ? (
        <Badge
          badgeContent={item?.quantity || 0}
          sx={{
            "& .MuiBadge-badge": {
              right: "5px",
              color: `${colors.white}`,
              "background-color": `${colors.ozone}`,
            },
          }}
        >
          <S.CartProductItemImageContainer>
            <img
              src={item.productImageUrl || defaultProductImageUrl}
              alt={item.productDescription}
              title={item.productDescription}
            />
          </S.CartProductItemImageContainer>
        </Badge>
      ) : (
        <S.CartProductItemImageContainer>
          <img
            src={item.productImageUrl || defaultProductImageUrl}
            alt={item.productDescription}
            title={item.productDescription}
          />
        </S.CartProductItemImageContainer>
      )}
    </S.CartProductItemContainer>
  ) : null;
};

export default CartProductItem;
